<template>
    <div class="translation-form">
        <b-row>
            <b-col cols="12" md="6">
                <b-form-group label="Başlık" label-for="title">
                    <b-form-input id="title" v-model="localValue.Title" placeholder="İçerik Başlığı" />
                </b-form-group>
            </b-col>

            <b-col cols="12" md="6">
                <b-form-group label="Kısa Başlık" label-for="shortTitle">
                    <b-form-input id="shortTitle" v-model="localValue.ShortTitle" placeholder="Kısa Başlık" />
                </b-form-group>
            </b-col>

            <b-col cols="12">
                <b-form-group label="Özet" label-for="summary">
                    <b-form-textarea id="summary" v-model="localValue.Summary" placeholder="Kısa Açıklama" rows="3" />
                </b-form-group>
            </b-col>

            <b-col cols="12">
                <b-form-group label="İçerik" label-for="content" class="editor-wrapper">
                    <quill-editor v-model="localValue.Content" :options="editorOptions" />
                </b-form-group>
            </b-col>

            <b-col cols="12" md="6">
                <b-form-group label="Yazar" label-for="author">
                    <b-form-input id="author" v-model="localValue.Author" placeholder="Yazar Adı" />
                </b-form-group>
            </b-col>
        </b-row>

        <hr class="my-2" />

        <div class="d-flex align-items-center mb-2">
            <feather-icon icon="SearchIcon" size="16" class="mr-50" />
            <h6 class="mb-0">SEO Bilgileri</h6>
        </div>

        <b-row>
            <b-col cols="12" md="6">
                <b-form-group label="SEO Başlık" label-for="seoTitle">
                    <b-form-input id="seoTitle" v-model="localValue.SeoTitle" placeholder="SEO için başlık" />
                </b-form-group>
            </b-col>

            <b-col cols="12" md="6">
                <b-form-group label="SEO Anahtar Kelimeler" label-for="seoKeywords">
                    <b-form-input id="seoKeywords" v-model="localValue.SeoKeywords" placeholder="keyword1, keyword2, keyword3" />
                </b-form-group>
            </b-col>

            <b-col cols="12">
                <b-form-group label="SEO Açıklama" label-for="seoDescription">
                    <b-form-textarea id="seoDescription" v-model="localValue.SeoDescription" placeholder="SEO için açıklama" rows="3" />
                </b-form-group>
            </b-col>

            <b-col cols="12" md="6">
                <b-form-group label="OG Image" label-for="ogImage">
                    <b-form-input id="ogImage" v-model="localValue.OgImage" placeholder="https://example.com/image.jpg" />
                </b-form-group>
            </b-col>

            <b-col cols="12" md="6">
                <b-form-group label="OG Image Alt" label-for="ogImageAlt">
                    <b-form-input id="ogImageAlt" v-model="localValue.OgImageAlt" placeholder="Görsel açıklaması" />
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { BRow, BCol, BFormGroup, BFormInput, BFormTextarea } from "bootstrap-vue";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

export default {
    name: "TranslationForm",
    components: {
        BRow,
        BCol,
        BFormGroup,
        BFormInput,
        BFormTextarea,
        quillEditor,
    },
    props: {
        value: {
            type: Object,
            required: true,
        },
        languageCode: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            editorOptions: {
                theme: "snow",
                placeholder: "İçeriği buraya yazın...",
                modules: {
                    toolbar: [
                        ["bold", "italic", "underline", "strike"],
                        ["blockquote", "code-block"],
                        [{ header: 1 }, { header: 2 }],
                        [{ list: "ordered" }, { list: "bullet" }],
                        [{ script: "sub" }, { script: "super" }],
                        [{ indent: "-1" }, { indent: "+1" }],
                        [{ size: ["small", false, "large", "huge"] }],
                        [{ header: [1, 2, 3, 4, 5, 6, false] }],
                        [{ color: [] }, { background: [] }],
                        [{ align: [] }],
                        ["clean"],
                        ["link", "image", "video"],
                    ],
                },
            },
        };
    },
    computed: {
        localValue: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            },
        },
    },
};
</script>

<style scoped>
.translation-form {
    padding: 1rem 0;
}

.editor-wrapper >>> .quill-editor {
    min-height: 300px;
}

.editor-wrapper >>> .ql-container {
    min-height: 250px;
}
</style>
